export enum MainSalaryTaxType {
FMY,
Multiplier,
Expression,
TaxFree,
}
